import React, { FC } from 'react';
import { MoonLoader } from 'react-spinners';
import colors from 'res/colors';
import classes from './index.module.scss';

/**
 * LoadingIndicator component
 * Renders a centered spinning loader animation
 * Used to indicate loading states throughout the application
 *
 * @returns {JSX.Element} - Rendered component
 */
const LoadingIndicator: FC = () => (
	<div className={classes['loading-indicator']}>
		{/* MoonLoader from react-spinners package */}
		<MoonLoader size={60} color={colors.tertiaryText} />
	</div>
);

export default LoadingIndicator;
